import ExportForm from "../common/ExportForm";

const EXPORT_COLUMNS = [
    { key: "poNumber", label: "PO Number" },
    { key: "poDate", label: "PO Date" },
    { key: "poType", label: "PO Type" },
    { key: "category", label: "Category" },
    { key: "projectId", label: "Project" },
    { key: "requesterId", label: "Requester" },
    { key: "approverId", label: "Approver" },
    { key: "department", label: "Department" },
    { key: "paymentMethod", label: "Payment Method" },
    { key: "last4", label: "Last 4" },
    { key: "billable", label: "Billable" },
    { key: "includedInProposal", label: "Included In Proposal" },
    { key: "clientInvoiceNumber", label: "Client Invoice Number" },
    { key: "notes", label: "Notes" },
    { key: "subtotal", label: "Subtotal" },
    { key: "tax", label: "Tax" },
    { key: "discount", label: "Discount" },
    { key: "total", label: "Total" },
    { key: "status", label: "Status" },
    { key: "paid", label: "Paid" },
    { key: "billed", label: "Billed" },
    { key: "approvalTime", label: "Approval Time" },
    { key: "approverNotes", label: "Approver Notes" },
    { key: "notifiedAt", label: "Notified At" },
    { key: "notifiedBy", label: "Notified By" },
    { key: "createdAt", label: "Created At" },
    { key: "creatorId", label: "Creator" },
    { key: "updatedAt", label: "Updated At" },
    { key: "updaterId", label: "Updated By" },
    { key: "void", label: "Void" },
    { key: "voidReason", label: "Void Reason" },
    { key: "validateReason", label: "Validate Reason" },
    { key: "lineItems", label: "Line Items" },
];

export default function PurchaseExportForm() {
    return <ExportForm columns = {EXPORT_COLUMNS} />;
}
